import { z } from "zod";

import { mediaSchema } from "../packaging-solution/packaging-component/packaging-component-base";

export const mediaSavedSchema = mediaSchema.extend({
	thickness: z.number().optional(),
});
